import {
  Component,
  OnInit,
  LOCALE_ID,
  Inject,
  OnDestroy,
  PLATFORM_ID
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { ActivatedRoute } from "@angular/router";
import { IPagination } from "./pagination/Ipagination";
import { ProductsMange } from "./productsManange";
import { Title, Meta } from "@angular/platform-browser";
import { LinkService } from "../../service/link.service";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-shop",
  templateUrl: "./shop.component.html",
  styleUrls: ["./shop.component.scss"]
})
export class CatogeryProducts extends ProductsMange implements OnInit {
  p = 1;
  pagination: IPagination;
  isBrowser: boolean;
  currentLangId: string;
  title: string;
  description: string;
  image: string;
  url: string;
  constructor(
    public _facadeService: FacadeService,
    private _route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale,
    @Inject(PLATFORM_ID) platformId: string,
    private titleService: Title,
    private metaService: Meta,
    private link: LinkService
  ) {
    super(_facadeService);
    this.isBrowser = isPlatformBrowser(platformId);
    this.currentLangId = this.locale;
  }

  ngOnInit() {
    this.getProducts();
    this.getAllCatogeries();
  }

  getAllCatogeries() {
    this._facadeService.Product.categories.subscribe(res => {
      this.categories = res.data;
      this.setSeoTagsProperties();
    });
  }

  getProducts() {
    this.products = [];
    this._route.paramMap.subscribe(params => {
      this.currentCatogery = JSON.parse(params.get("id"));
      this._facadeService.Product.filterProducts({
        category_id: params.get("id"),
        page: this.p
      }).subscribe(res => {
        this.setProductRespone(res);
        this.pagination = {
          currentPage: res.data.current_page,
          lastPage: res.data.last_page
        };
      });
    });
  }

  onLoad(index: number) {
    this.loaded(index);
  }

  pageChanged(page) {
    // Change the current page
    this.pagination.currentPage = page;
    this.p = page;

    // Scroll to top
    window.scroll(0, 0);

    // Get the new page data
    this.getProducts();
  }

  setSeoTagsProperties() {
    const currentUrlLang = this.currentLangId === "en" ? "" : "ar/";
    const currentCat = this.getCategory();
    if (this.currentLangId === "ar") {
      this.title =
        "نيو فرنتشر للاثاث المكتبي | " + currentCat.name + " المناسب لمكتبك";
      this.description = `نيو فرنتشر بتوفرلك جميع الأنواع والمقأسات المختلفة - ${currentCat.name} بأفضل جودة وأرخص الأسعار`;
    } else {
      this.title =
        "New furniture Egypt | the suitable " +
        currentCat.name +
        " for your office";
      this.description =
        "New furniture provides for you all the different types and sizes of " +
        currentCat.name +
        " with the best quality and least prices.";
    }
    this.url = `https://newfurniture-eg.com/${currentUrlLang}products/${currentCat.id}`;
    this.link.addTag({
      rel: "",
      href: this.url
    });

    this.setSeoTags(this.title, this.description, currentCat.image, this.url);
  }

  getCategory() {
    for (let i = 0; i < this.categories.length; i++) {
      if (this.currentCatogery === this.categories[i].id) {
        return this.categories[i];
      } else {
        continue;
      }
    }
  }

  setSeoTags(Title, description, img, url, currentPage?): void {
    this.removeCurrentTags();
    if (!img) {
      img = "https://www.newfurniture-eg.com/assets/logo.png";
    }
    this.titleService.setTitle(Title);
    this.metaService.addTags([
      {
        name: "description",
        content: description
      },
      {
        itemprop: "description",
        name: "og:description",
        content: description
      },
      {
        itemprop: "description",
        content: description
      },
      {
        name: "twitter:description",
        content: description
      },
      {
        name: "og:title",
        content: Title
      },
      {
        name: "og:type",
        content: "article"
      },
      {
        name: "og:url",
        content: url
      },
      {
        name: "og:image",
        content: img
      },
      {
        name: "twitter:card",
        content: "summary"
      },
      {
        name: "twitter:title",
        content: Title
      },
      {
        name: "twitter:image",
        content: img
      },
      {
        itemprop: "name",
        content: Title
      },
      {
        itemprop: "image",
        content: img
      }
    ]);

    this.addLinkTagtoPage(currentPage, url);
  }

  addLinkTagtoPage(currentPage, url): void {
    const alternativeLng = this.currentLangId === "en" ? ".com/ar/" : ".com/",
      altLang = this.currentLangId === "ar" ? "en" : "ar";

    const locle = this.currentLangId == "en" ? "en_US" : "ar_AR",
      alte = this.currentLangId != "en" ? "en_US" : "ar_AR";
    this.link.removeTag('rel="canonical"');
    this.link.removeTag('rel="alternate"');

    this.link.addTag({
      rel: "canonical",
      href: url,
      hreflang: this.currentLangId + "-eg"
    });
    this.link.addTag({
      rel: "alternate",
      href:
        this.currentLangId === "en"
          ? url.replace(`.com/`, `${alternativeLng}`)
          : url.replace(`.com/ar/`, `${alternativeLng}`),
      hreflang: altLang + "-eg"
    });

    this.metaService.addTag({
      property: "og:locale",
      content: `${locle}`
    });
    this.metaService.addTag({
      property: "og:locale:alternate",
      content: `${alte}`
    });
  }

  removeCurrentTags(): void {
    if (this.isBrowser) {
      this.metaService.removeTag(" name ='twitter:description'");
      this.metaService.removeTag(" name ='og:description'");
      this.metaService.removeTag(" name ='description'");
      this.metaService.removeTag("itemprop='description'");
      this.metaService.removeTag(" name = 'og:title' ");
      this.metaService.removeTag(" name ='og:url'");
      this.metaService.removeTag(" name ='og:image'");
      this.metaService.removeTag(" name ='og:locale:alternate'");
      this.metaService.removeTag(" name ='og:locale:alternate'");

      this.metaService.removeTag(" name ='twitter:title'");
      this.metaService.removeTag(" name ='twitter:image'");
      this.metaService.removeTag(" itemprop ='name'");
      this.metaService.removeTag(" itemprop ='image'");
    }
  }
}
